import { format } from 'date-fns';
import { EMPTY } from '../utils';
import moment from 'moment';

export class DateUtils {
    static DATE_MASK_PATTERN = '99/99/9999';

    static DATE_PATTERN_WITH_SLASH = 'dd/MM/yyyy';

    static isBefore(date: Date, other: Date) {
        return date.getTime() <= other.getTime();
    }

    static isAfter(date: Date, other: Date) {
        return date.getTime() >= other.getTime();
    }

    static isEqual(date: Date, other: Date) {
        return this.toYearMonthDay(date).getTime() === this.toYearMonthDay(other).getTime();
    }

    static toString(date: Date, pattern?: string) {
        if (!pattern) pattern = this.DATE_PATTERN_WITH_SLASH;
        return format(date, pattern);
    }

    static parseStringFromPatternWithSlash(date: Date): string {
        const value = format(date, this.DATE_PATTERN_WITH_SLASH).split('/');
        return EMPTY.concat(...value);
    }

    static parseDate(date: string): Date {
        const day: number = Number.parseInt(date.substring(0, 2));
        const month: number = Number.parseInt(date.substring(2, 4));
        const year: number = Number.parseInt(date.substring(4));
        return new Date(year, month - 1, day);
    }

    static fromLocalToGlobalUTC(date: Date) {
        if (!date) return null;
        date.setHours(date.getHours() + moment(date).utcOffset() / 60);

        return date;
    }

    static parseLocalDateTimeWithSeconds(localDate: string | any[]): Date {
        if (!localDate) {
            return null;
        }

        if (typeof localDate === 'string') {
            return new Date(localDate);
        }

        if (Array.isArray(localDate) && localDate.length >= 6) {
            const values = localDate
                .map((s) => ''.concat(s))
                .map((s) => (s.length === 1 ? '0'.concat(s) : s));
            return new Date(
                `${values[0]}-${values[1]}-${values[2]}T${values[3]}:${values[4]}:${values[5]}`
            );
        }
        return null;
    }

    static normalizeDate(date: Date): Date {
        const parseDate: Date = new Date(date);
        parseDate.setDate(parseDate.getDate() + 1);
        return parseDate;
    }

    static calculateEventDate(months?: number, days?: number): Date {
        const date: Date = new Date();
        date.setMonth(date.getMonth() - months);
        date.setDate(date.getDate() - days);
        return date;
    }

    public static toYearMonthDay(date: Date): Date {
        return new Date(date.getFullYear(), date.getMonth(), date.getDate());
    }
}
